var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_6824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7709 9.29074L19.7702 9.29L15.688 5.2275C15.3821 4.92316 14.8875 4.92429 14.5831 5.23015C14.2787 5.53597 14.2799 6.03062 14.5857 6.335L17.3265 9.0625H0.78125C0.349766 9.0625 0 9.41226 0 9.84375C0 10.2752 0.349766 10.625 0.78125 10.625H17.3264L14.5857 13.3525C14.2799 13.6569 14.2788 14.1515 14.5831 14.4573C14.8875 14.7632 15.3822 14.7643 15.688 14.46L19.7702 10.3975L19.7709 10.3968C20.0769 10.0914 20.0759 9.59512 19.7709 9.29074Z",
    fill: "#FF6000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_6824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorarrow);
export default __webpack_public_path__ + "static/media/colorarrow.ce0db466c5c0c4985ed7460fec63ff0c.svg";
export { ForwardRef as ReactComponent };